export const environment = {
    api : {
        server: "https://api.mypopstoreapp.com",
        context: "/mybusinessapp-api/api",
        username: 'mypostoreapp',
        password: 'p98WLo#ldJ9awb#cdK3yoO#!Q',
    }
}
